
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-conservation-readonly',
    imports: [],
    templateUrl: './conservation-readonly.component.html',
    styleUrl: './conservation-readonly.component.scss'
})
export class ConservationReadonlyComponent {

  @Input() conservationData: any = null;

}
